import type { Geofence, ResolvedPlace } from '@gpx-spa/geo-domain';
import {
  stopRadiusDefaultM,
  type ShipmentStopRole,
} from '@/components/shipment/form/domain/account-defaults';

export interface ShipmentFormSelectedDevice {
  id: number;
  label: string;
}

export interface ShipmentFormStopRow {
  key: string;
  radiusM: number;
  resolved: ResolvedPlace | null;
  geofence: Geofence | null;
  plannedArrival: Date | null;
  plannedDeparture: Date | null;
  persistedStopId?: number;
}

let keySeq = 0;

export function generateStopKey(): string {
  return `stop-${++keySeq}-${Date.now().toString(36)}`;
}

export function createEmptyStop(
  role: ShipmentStopRole = 'waypoint',
): ShipmentFormStopRow {
  return {
    key: generateStopKey(),
    radiusM: stopRadiusDefaultM(role),
    resolved: null,
    geofence: null,
    plannedArrival: null,
    plannedDeparture: null,
  };
}
